export default {"src":"/_next/static/media/Vector-triangles.d2b3e2bd.svg","height":99,"width":196,"blurWidth":0,"blurHeight":0};